<template>
  <!--app活动团长管理-->
  <div>
    <x-tabula
      ref="table"
      rowKey="leaderId"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
          <template slot="opt_status" slot-scope="{row}">
            <div style="display: flex; align-items: center">
              <span class="circle-dot" :class="statusColor[row.status] + '-bg'"></span>
              <span>{{statusObj[row.status]}}</span>
            </div>
          </template>
    </x-tabula>

    <!--新增团长的弹窗-->
    <a-modal
      :title="modalTitle"
      :visible="visible"
      @cancel="visible=false"
      @ok="$refs.addEdit.handleSubmit()"
      :confirmLoading="btnLoading.loading"
      v-bind="$store.state.modalConfig"
      width="700px"
    >
      <x-addEdit
        ref="addEdit"
        formType="modal"
        :isSubmitBtn="false"
        :itemLayout="$store.state.modal_ItemLayout"
        :reqLoading="btnLoading"
        :formList="formList"
        :formKey="formKey"
        :addParam="addParam"
        :editParam="editParam"
        :detailParam="detailParam"
      >
        <template slot="1" slot-scope="{formItem}">
          <a-form-item v-if="formItem.show" :label="formItem.label" required v-bind="$store.state.modal_ItemLayout">
              <a-input v-decorator="formItem.props" :placeholder="formItem.placeholder"/>
          </a-form-item>
        </template>
      </x-addEdit>
    </a-modal>
  </div>
</template>

<script>
import { fetchSelect } from '@/utils/mixins';
export default {
  name: 'activityLeader',
  mixins: [fetchSelect],
  data () {
    return {
      modalTitle: '新增团长',
      visible: false,
      btnLoading: { loading: false },
      formList: [
        {
          label: '类型',
          inputType: 'select',
          options: [],
          placeholder: '请选择',
          handle: this.dataTypeChange,
          disabled: false,
          props: ['type', {
            rules: [{required: true, message: '请选择团长类型'}]
          }]
        },
        {
          label: '手机号',
          inputType: 'input',
          options: [],
          placeholder: '请输入手机号',
          disabled: false,
          props: ['mobilePhone', {
            rules: [
              {required: true, message: '请输入手机号'}
            ]
          }]
        },
        {
          slot: '1',
          show: false,
          label: '开户行',
          inputType: 'input',
          placeholder: '请输入开户行支行名称',
          props: ['depositBank', {
            rules: [{required: true, message: '请输入开户行支行名称'}]
          }]
        },
        {
          slot: '1',
          show: false,
          label: '银行账号',
          inputType: 'input',
          placeholder: '请输入银行账号',
          props: ['cardNumber', {
            rules: [{required: true, message: '请输入银行账号'}]
          }]
        },
        {
          slot: '1',
          show: false,
          label: '账户名称',
          inputType: 'input',
          placeholder: '请输入账户名称',
          props: ['accountName', {
            rules: [{required: true, message: '请输入账户名称'}]
          }]
        }
      ],
      formKey: {
        type: undefined,
        mobile: undefined,
        depositBank: undefined,
        cardNumber: undefined,
        accountName: undefined
      },
      addParam: {
        url: '/activity/leader/add',
        resHandle: () => this.addEditResHandle('新增')
      },
      editParam: {
        url: '/activity/leader/',
        reqHandle: () => this.editReqHandle(), // this.addReqHandle
        resHandle: () => this.addEditResHandle('编辑')
      },
      detailParam: {
        url: '',
        resHandle: '' // this.detailResHandle
      },

      searchList: [
        { props: ['mobilePhone'], placeholder: '手机号', inputType: 'input' },
        { props: ['type'], placeholder: '类型', options: [], inputType: 'select' }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', handle: this.openModal, permi: ['community:activityLeader:add'] }
      ],
      rowOptList: [
        // { text: '重置密码', handle: row => this.resetPwd(row.encrypt_id), key: 'resetPwd' },
        { text: '编辑', handle: (row) => this.editHandle(row), permi: ['community:activityLeader:edit'] },
        {
          text: '',
          handle: row => this.changeStatus(row),
          customRender: true,
          rowOptText: row => row.status === 1 ? '禁用' : '启用',
          permi: ['community:activityLeader:status']
        }
      ],
      columns: [
        { title: '昵称', dataIndex: 'nickName', align: '', width: '' },
        { title: '手机号', dataIndex: 'mobilePhone', align: '', width: '' },
        { title: '账号类型', dataIndex: 'typeDesc', align: '', width: '' },
        { title: '状态', dataIndex: 'status', align: '', width: '', scopedSlots: {customRender: 'status'} },
        { title: '操作', dataIndex: 'action', align: '', width: '', scopedSlots: {customRender: 'action'} }
      ],
      statusObj: ['停用', '启用'], // 账号状态:0停用, 1启用
      statusColor: ['info', 'success'],
      dataSource: [],
      searchParams: {
        mobilePhone: undefined,
        type: undefined
      },
      listApi: {
        url: '/activity/leader/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: '',
        addTitle: '',
        editTitle: ''
      },
      deleteParam: {
        url: '',
        title: '',
        key: '',
        resHandle: '' // 执行完删除的回调方法
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    /** 获取团长类型下拉 */
    getSelect () {
      this.$get({
        url: '/dict/data/dictType/comu_activity_leader_type',
        params: {}
      }).then(({data}) => {
        this.formList[0].options = data;
        this.searchList[1].options = data;
      });
    },
    /** 根据团长类型切换输入框 */
    dataTypeChange (val) {
      this.formList.forEach((el) => {
        el.slot === val ? el.show = true : el.show = false;
      });
    },
    /* 切换状态 */
    changeStatus (row) {
      let status = row.status === 1 ? 0 : 1;
      this.$put({
        url: `/activity/leader/changeStatus/${row.leaderId}`,
        params: { status: status }
      }).then(({data}) => {
        this.$message.success('状态切换成功！');
        this.$refs.table.getTableList();
      });
    },
    /** 新增团长 */
    openModal () {
      this.modalTitle = '新增团长';
      this.visible = true;
      let mobileRules = this.formList[1].props[1].rules;
      mobileRules.splice(1, 1);

      (mobileRules.push({ pattern: this.REG.mobile, message: this.MESSAGE.mobile }));
      this.formList.forEach((el) => {
        if (el.disabled) {
          el.disabled = false;
        }
      });
      this.dataTypeChange();
      // this.$nextTick(() => {
      //   this.getSelect();
      // });
    },
    editHandle (row) {
      this.modalTitle = '编辑团长';
      this.$get({
        url: `/activity/leader/info/${row.leaderId}`,
        params: {}
      }).then(({data}) => {
        this.dataTypeChange(row.type + '');
        this.visible = true;
        let mobileRules = this.formList[1].props[1].rules;
        mobileRules.splice(1, 1);
        this.$nextTick(() => {
          this.$refs.addEdit.form.setFieldsValue({
            type: data.type + '',
            mobilePhone: data.mobilePhone,
            depositBank: data.depositBank,
            cardNumber: data.cardNumber,
            accountName: data.accountName
          });
          this.$refs.addEdit.routeQuery = row.leaderId;
          this.formList.forEach((el) => {
            el.disabled = true;
          });
        });
      });
    },
    editReqHandle () {
      this.formList.formList;
    },
    // 添加编辑返回处理
    addEditResHandle (msg) {
      this.$message.success(`${msg}成功`);
      this.visible = false;
      this.$refs.table.getTableList();
    },
    resHandle (res) {
      this.visible = false;
      this.$refs.table.getTableList();
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>
